<template>
  <v-row align="center">
    <v-col cols="3">
      <v-select
        v-model="localCondition.field"
        :items="availableFields"
        item-text="label"
        item-value="value"
        label="Field"
        dense
        outlined
        hide-details
        @change="onFieldChange"
      ></v-select>
    </v-col>

    <v-col cols="3">
      <filter-operator-select
        v-model="localCondition.operator"
        :operators="operators"
        @change="onOperatorChange"
      ></filter-operator-select>
    </v-col>

    <v-col :cols="hasTwoValues ? 2 : 5">
      <filter-value-input
        v-model="localCondition.value"
        :field="currentField"
        :operator="localCondition.operator"
      ></filter-value-input>
    </v-col>

    <v-col v-if="hasTwoValues" cols="3">
      <filter-value-input
        v-model="localCondition.value2"
        :field="currentField"
        :operator="localCondition.operator"
        :is-second-value="true"
      ></filter-value-input>
    </v-col>

    <v-col cols="1">
      <v-btn icon @click="$emit('remove')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import FilterOperatorSelect from "./FilterOperatorSelect.vue";
import FilterValueInput from "./FilterValueInput.vue";
import { FILTER_TYPES } from "../../../consts/filterTypes";

export default {
  name: "FilterCondition",
  components: {
    FilterOperatorSelect,
    FilterValueInput,
  },
  props: {
    condition: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    usedFields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localCondition: { ...this.condition },
    };
  },
  computed: {
    availableFields() {
      // Filter out fields that are already used in other conditions
      // Include the current field in the available fields
      return this.fields.filter(
        (field) =>
          !this.usedFields.includes(field.value) ||
          field.value === this.localCondition.field
      );
    },
    currentField() {
      return (
        this.fields.find((f) => f.value === this.localCondition.field) || {}
      );
    },
    operators() {
      const fieldType = this.currentField.type || "TEXT";
      return FILTER_TYPES[fieldType].operators;
    },
    hasTwoValues() {
      return ["between", "not_between"].includes(this.localCondition.operator);
    },
  },
  watch: {
    condition: {
      handler(val) {
        this.localCondition = { ...val };
      },
      deep: true,
    },
    localCondition: {
      handler(val) {
        this.$emit("update:condition", val);
      },
      deep: true,
    },
  },
  methods: {
    onFieldChange() {
      // Reset operator and value when field changes
      const fieldType = this.currentField.type || "TEXT";
      this.localCondition.operator = FILTER_TYPES[fieldType].operators[0].value;
      this.localCondition.value = null;
      this.localCondition.value2 = null;
    },
    onOperatorChange() {
      // Reset values when operator changes
      this.localCondition.value = null;
      this.localCondition.value2 = null;
    },
  },
};
</script>